<template>
  <v-card
    class="mx-auto overflow-visible"
    width="800px"
    style="margin-top: 0px; margin-bottom: 0px;"
    outlined
  >
    <v-list-item three-line>
      <validation-observer v-slot="{ handleSubmit }">
        <v-list-item-content class="overflow-visible">
          <v-row class="align-center">
            <v-col cols="10">
              <v-list-item-title class="headline mb-2">Tìm kiếm</v-list-item-title>
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon aria-label="Close" @click="closeMenu">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                  placeholder="Nhập mã kích hoạt"
                  v-model="filterForm.activeCode"
                  label="Mã kích hoạt"
                  clearable
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filterForm.status"
                :items="statusActiveCodeList"
                item-text="name"
                item-value="code"
                label="Trạng thái mã"
                placeholder="Chọn trạng thái"
                clearable
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                  placeholder="SĐT kích hoạt"
                  v-model="filterForm.activationPhone"
                  label="SĐT kích hoạt"
                  clearable
              />
            </v-col>

            <v-col cols="12" md="4">
              <common-range-picker
                :clearable="true"
                :aLight="'center'"
                label="Ngày tạo mã"
                v-model="filterForm.createdAt"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                  placeholder="Nhân viên tạo"
                  v-model="filterForm.staffName"
                  label="Nhân viên tạo"
                  clearable
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filterForm.type"
                :items="statusActiveCodeType"
                item-text="name"
                item-value="id"
                label="Kiểu mã"
                placeholder="Kiểu mã"
                clearable
              />
            </v-col>

            <v-col cols="12" md="4">
              <common-range-picker
                  :clearable="true"
                  :aLight="'center'"
                  label="Ngày kích hoạt"
                  v-model="filterForm.activatedAt"
              />
            </v-col>
          </v-row>
          <div class="d-flex text-center mb-4 justify-center">
            <v-btn class="primary mx-0" @click.prevent="handleSubmit(searchActiveCode)">
              <v-icon>mdi-dropdown</v-icon>Tìm kiếm
            </v-btn>
            <div  class="d-flex ml-5 group-input">
              <v-btn v-if="checkAuthorization('agency-admin_download')"
                     class="primary mx-0 download"
                     @click.prevent="handleSubmit(exportExcel)">
                <v-icon>mdi-download</v-icon>Download
              </v-btn>
            </div>
          </div>
        </v-list-item-content>
      </validation-observer>
    </v-list-item>
  </v-card>
</template>
<script>
import TokenService from '../../../../../helpers/token';
import RepositoryFactory from '../../../../../repositories/RepositoryFactory';
import { downloadFile } from '../../../../../helpers/utils';
import AgencyRepository from "../../../../../repositories/AgencyRepository";
const ProductRepository = RepositoryFactory.get('product');
export default {
  props: {
    filterForm: {
      type: Object,
      default: () => ([])
    },
    statusActiveCodeType: {
      type: Array,
      default: () => ([])
    },
    statusActiveCodeList: {
      type: Array,
      default: () => ([])
    },
    openMenu: {
      type: Boolean,
      default: () => false
    },
    activeCodeList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {

    };
  },
  computed: {

  },
  async created() {

  },

  beforeDestroy() {

  },
  methods: {
    closeMenu() {
      Bus.$emit('close-menu-filter-active-code')
    },
    async getProducts() {
      const respond = await ProductRepository.list({
        limit: 1000,
        groupId: this.filterForm.groupId
      });
      if (_.get(respond, 'success', false)) {
        this.products = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    searchActiveCode() {
      let filterForm = _.cloneDeep(this.filterForm)
      Bus.$emit('active-code-list-filter', filterForm);
    },
    checkEmptyFilterForm() {
      let isExist = false;
      const isExistKeyword = !!this.filterForm.keyword;
      const isExistMinistryId = !!this.filterForm.ministryIds;
      const isExistUserId = !!this.filterForm.userIds;
      const isExistGroupId = !!this.filterForm.groupId;
      const isExistProductId = !!this.filterForm.productId;
      const isExistPaymentType = !!this.filterForm.paymentType;
      const isExistCreatedAt = _.isArray(this.filterForm.createdAt) ? !!this.filterForm.createdAt.length : false;
      const isExistStatusIds = _.isArray(this.filterForm.statusIds) ? !!this.filterForm.statusIds.length : false;

      isExist = isExistKeyword || isExistMinistryId || isExistUserId || isExistGroupId || isExistProductId || isExistPaymentType || isExistCreatedAt || isExistStatusIds;
      return isExist;
    },
    async exportExcel() {
      // if (!this.checkEmptyFilterForm()) {
      //   this.$swal({
      //   type: 'error',
      //   title: 'Lỗi !',
      //   text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
      //   })
      //   return;
      // }

      let listContactSelected = this.activeCodeList.filter(contact => contact.checkbox);
      const loader = this.$loading.show();
      let user = await TokenService.getUser()
      const params = {
        agencyId: this.filterForm.agencyId,
        activeCode: this.filterForm.activeCode,
        staffName: this.filterForm.staffName,
        status: this.filterForm.status,
        activationPhone: this.filterForm.activationPhone,
        typeOfCode: this.filterForm.typeOfCode, // Mã đại lý
        type: this.filterForm.type,
        fromActivationAt: this.filterForm.activatedAt[0] ? this.filterForm.activatedAt[0] : '',
        toActivationAt: this.filterForm.activatedAt[1] ? this.filterForm.activatedAt[1] : '',
        fromCreatedAt: this.filterForm.createdAt[0] ? this.filterForm.createdAt[0] : '',
        toCreatedAt: this.filterForm.createdAt[1] ? this.filterForm.createdAt[1] : '',
        activeCodeIds: listContactSelected.map(ac => ac.id)
      }
      const res = await AgencyRepository.exportExcelActiveCode({...params, username: user.username})
      loader.hide();
      if (res.success) {
        this.$swal({
          text: 'Tải xuống dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        })
        await downloadFile(_.get(res, 'data.csvFile', ''), _.get(res, 'data.fileName', ''));
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
    }
  }
};
</script>

<style scoped>
.download {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}

.dropdown {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  min-width: 35px !important;
  width: 30px;
  position: absolute;
  right: -30px;
}

/deep/ .daterangepicker.show-ranges.show-weeknumbers[data-v-657333f3], .daterangepicker.show-ranges[data-v-657333f3] {
    min-width: 706px;
}
</style>